import { getBildebankenHost, getRelease } from "../config";
import { getEnvironmentFromHostname } from "../utils/fns";
import { getAppContext } from "../services/fetch-wrapper";
import { pageState } from "../state/page";
import { get } from "svelte/store";
import { isPlugin } from "state/app";

//Finner vi Sentry instance typen noe sted?
let Sentry;

export function initSentry() {
  const env = getEnvironmentFromHostname(getBildebankenHost().hostname);
  if (env === "stage" || env === "pr" || env === "prod" || env === "beta") {
    import("@sentry/svelte").then((sentry) => {
      Sentry = sentry;
      Sentry.init({
        dsn: "https://0c1305aa0fa11f1b8f2b40f49858fcb5@o124059.ingest.sentry.io/4506268959440896",
        integrations: [new Sentry.BrowserTracing()],
        tracesSampleRate: 0.2,
        tracePropagationTargets: ["localhost", "bildebanken", "microsoftonline", "amazonaws"],
        release: getRelease(),
        environment: env,
        beforeSend(event) {
          event.tags = {
            ...event.tags,
            isEmbedded: isPlugin,
            appContext: getAppContext(),
          };
          event.extra = {
            ...event.extra,
            pageState: get(pageState),
          };
          return event;
        },
      });
    });
  }
}

export function sentryCaptureException(exception) {
  if (Sentry) {
    Sentry.captureException(exception);
  } else {
    console.warn("sentryCaptureException called with no sentry instance");
  }
}

export function sentryAddBreadcrumb(category, breadcrumb) {
  if (Sentry) {
    Sentry.addBreadcrumb({
      category,
      message: JSON.stringify(breadcrumb),
      level: "info",
    });
  }
}

export function getTraceId() {
  const activeSpan = Sentry?.getActiveSpan();
  return activeSpan?.traceId;
}
